import { useMutation, useQueryClient } from '@tanstack/react-query'
import { recordShiftWorkBreak } from 'api/shifts/recordShiftWorkBreak'
import { shiftDetailKey } from './keys'

export const useRecordShiftWorkBreakMutation = (shiftId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: recordShiftWorkBreak,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: shiftDetailKey(shiftId) })
    },
  })
}
